import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { BellIcon } from 'lucide-react';
import { EauAtna } from '../components/eau/EauAtna';
import { MeterAddressCard } from '../components/eau/MeterAddressCard';
import { ConsumptionCard } from '../components/eau/ConsumptionCard';
import { WaterInsight } from '../components/eau/WaterInsight';
import { WaterTips } from '../components/eau/WaterTips';
import { AlertPreferences } from '../components/eau/AlertPreferences';
import { WaterBillCard } from '../components/eau/WaterBillCard';
import { WaterPaymentDialog } from '../components/eau/WaterPaymentDialog';
export function MonCompteurEau() {
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [paid, setPaid] = useState(false);
  const alertsRef = useRef<HTMLDivElement | null>(null);
  const openAlerts = () => {
    setAlertsOpen(true);
    window.setTimeout(() => alertsRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    }), 60);
  };
  return <main className="bg-white" data-id="element-3014" data-mp="3frykl3oy55ag">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-3015" data-mp="3ft06k37i3c6y">
        <nav aria-label="Fil d’Ariane" className="text-sm font-semibold text-slate-500" data-id="element-3016" data-mp="3143nzc7tigs3">
          <Link to="/" className="transition-colors duration-150 ease-ville hover:text-ville-blue" data-id="element-3017" data-mp="361vqt1a03nb2">
            Accueil
          </Link>
          <span aria-hidden="true" data-id="element-3018" data-mp="3ttauaxdikanw"> › </span>
          <span className="text-ville-navy" data-id="element-3019" data-mp="2lolkqbxti06">Mon compteur d’eau</span>
        </nav>

        <header className="mt-4" data-id="element-3020" data-mp="2jlwc8ilzswi">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3021" data-mp="3kruo71tqeuph">
            Mon compteur d’eau
          </h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-3022" data-mp="3orbtnv95rrun">
            Suivez la consommation de votre résidence heure par heure, repérez les fuites, réduisez votre
            facture et payez en ligne.
          </p>
        </header>

        <div className="mt-8" data-id="element-3023" data-mp="jvk5hzdazh12">
          <EauAtna onConfigureAlerts={openAlerts} onPay={() => setPaymentOpen(true)} data-id="element-3024" data-mp="juhgxy3gdqob" />
        </div>

        <div className="mt-6" data-id="element-3025" data-mp="ewfzfhlodzey">
          <MeterAddressCard data-id="element-3026" data-mp="eya9u1zbm94s" />
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[minmax(0,1fr)_360px] lg:gap-8" data-id="element-3027" data-mp="a460jc2l1p0j">
          <div className="flex min-w-0 flex-col gap-6" data-id="element-3028" data-mp="56nym5mzga21">
            <ConsumptionCard data-id="element-3029" data-mp="541u6eve2ao1" />
            <WaterInsight onConfigureAlerts={openAlerts} data-id="element-3030" data-mp="149frljbdaar" />
          </div>

          <div className="flex flex-col gap-6" data-id="element-3031" data-mp="126kalze6oyn">
            <WaterBillCard paid={paid} onPay={() => setPaymentOpen(true)} data-id="element-3032" data-mp="3s9srgolbl9k9" />

            <div ref={alertsRef} data-id="element-3033" data-mp="3nb7q2luc0ju8">
              <AnimatePresence initial={false} data-id="element-3034" data-mp="3nciy4xut8dr5">
                {alertsOpen ? <AlertPreferences key="alertes" onClose={() => setAlertsOpen(false)} data-id="element-3035" data-mp="3idpt7ttl9v2l" /> : <section className="rounded-3xl border border-slate-200 bg-white p-6" data-id="element-3036" data-mp="1lj35jvf5wotj">
                    <h2 className="flex items-center gap-2 text-lg font-extrabold tracking-tight text-ville-navy" data-id="element-3037" data-mp="1gmcph83cxt84">
                      <BellIcon className="h-5 w-5 text-ville-blue" aria-hidden="true" data-id="element-3038" data-mp="1p1sgmhrczduv" />
                      Mes alertes
                    </h2>
                    <p className="mt-1 text-sm text-slate-600" data-id="element-3039" data-mp="1xuvq6eyvv6k8">
                      Fuite probable et nouvelle facture sont actives, par courriel et notification mobile.
                    </p>
                    <button type="button" onClick={openAlerts} className="mt-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-5 py-2.5 text-sm font-bold text-ville-deep transition-colors duration-150 ease-ville hover:border-ville-blue hover:text-ville-blue focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-3040" data-mp="163fxc36qgnlk">
                      Configurer mes alertes
                    </button>
                  </section>}
              </AnimatePresence>
            </div>
          </div>
        </div>

        <div className="mt-12" data-id="element-3041" data-mp="8apyefnfcwub">
          <WaterTips data-id="element-3042" data-mp="8c144l0fkeo2" />
        </div>
      </div>

      <WaterPaymentDialog open={paymentOpen} onClose={() => setPaymentOpen(false)} onPaid={() => setPaid(true)} data-id="element-3043" data-mp="3blt403mfj99" />
    </main>;
}